module.exports = {"name":"admin","version":"2d53bd8","description":"admin and settings","author":"Vnext AB","license":"ISC","scripts":{"test":"eslint --max-warnings 0 **/*.{js,jsx}"},"devDependencies":{"babel-eslint":"^7.2.3","eslint":"^4.6.1","eslint-config-react-app":"^2.0.0","eslint-plugin-flowtype":"^2.35.1","eslint-plugin-import":"^2.7.0","eslint-plugin-jsx-a11y":"^5.1.1","eslint-plugin-react":"^7.3.0","husky":"^0.14.3","lint-staged":"^4.0.4","prettier":"^1.6.1"},"precommit":"lint-staged","lint-staged":{"**/*.{js,jsx,json,css}":["prettier --single-quote --write","git add"]}}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/admin/package.json
// module id = 418
// module chunks = 9